var React = require('react');

function Grip (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17,16a4,4,0,1,0-4-4A3.9989,3.9989,0,0,0,17,16Zm0,4a4,4,0,1,0,4,4A3.9989,3.9989,0,0,0,17,20Zm0,12a4,4,0,1,0,4,4A3.9989,3.9989,0,0,0,17,32Z","key":0}),React.createElement("path",{"d":"M31,16a4,4,0,1,0-4-4A3.9989,3.9989,0,0,0,31,16Zm0,4a4,4,0,1,0,4,4A3.9989,3.9989,0,0,0,31,20Zm0,12a4,4,0,1,0,4,4A3.9989,3.9989,0,0,0,31,32Z","key":1})]);
}

Grip.displayName = "Grip";

Grip.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Grip;

Grip.default = Grip;



// WEBPACK FOOTER //
// ./node_modules/pui-css-iconography/svgs/grip.svg